/**
 * CRO-WEB-178 Signup Form Email Button Experimentation
 *
 * Gets the experiment variant from PostHog feature flag.
 * This experiment tests showing a "Continue with Email" button vs showing the form directly.
 */

import posthog from "posthog-js";
import { useFeatureFlagVariantKey } from "posthog-js/react";

export type CroWeb178Variant = "control" | "continue-with-email";

/**
 * Hook to get the CRO-WEB-178 experiment variant
 * Returns the variant string or null if not assigned
 */
export const useCroWeb178Variant = () => {
  const variant = useFeatureFlagVariantKey("cro-web-178");

  return {
    variant: (typeof variant === "string"
      ? variant
      : null) as CroWeb178Variant | null,
    isInitialized: true,
  };
};

/**
 * Get variant from PostHog feature flag (client-side only)
 * Used for experiment tracking configuration
 */
export const getCroWeb178Variant = (): CroWeb178Variant | null => {
  if (typeof window === "undefined") return null;

  try {
    const variant = posthog.getFeatureFlag("cro-web-178");
    return (
      typeof variant === "string" ? variant : null
    ) as CroWeb178Variant | null;
  } catch (error) {
    return null;
  }
};
